<template>
    <common-modal
        :width="'medium'"
        :showCloseButton="showCloseButton"
        @emitEvent="emitEvent($event, ['close'])"
        @close="emitEvent({ name: 'close' })"
    >
        <common-content-spacer height="medium">
            <header>
                <common-icon v-if="showBellIcon" name="bell" size="gigantic"></common-icon>
                <referrals-counter-component
                    v-if="totalNumber"
                    :currentIndex="currentIndex"
                    :totalNumber="totalNumber"
                ></referrals-counter-component>

                <p>
                    <strong>{{ patientName }}</strong>
                    {{ $t('pages.referrals.update.patient_seen.is_patient_seen_modal.heading.was_scheduled_for') }}
                </p>
            </header>

            <main>
                <div class="appointment_date">
                    <referrals-datetime :referral="referral"></referrals-datetime>
                </div>
                <h4>{{ $t('pages.referrals.update.patient_seen.is_patient_seen_modal.was_patient_seen') }}</h4>
            </main>

            <footer>
                <common-buttons>
                    <common-button
                        :label="$t('pages.referrals.update.patient_seen.is_patient_seen_modal.buttons.didnt_show')"
                        type="secondary"
                        size="large"
                        @click="emitEvent({ name: 'patient-seen', payload: { status: 'no-show' } })"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.update.patient_seen.is_patient_seen_modal.buttons.patient_seen')"
                        type="primary"
                        size="large"
                        @click="emitEvent({ name: 'patient-seen', payload: { status: 'patient-seen' } })"
                    ></common-button>
                    <common-button
                        :label="$t('pages.referrals.update.patient_seen.is_patient_seen_modal.buttons.skip_all')"
                        type="secondary"
                        size="large"
                        @click="emitEvent({ name: 'skip-all' })"
                    ></common-button>
                </common-buttons>
            </footer>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    import dayjs from 'dayjs'
    import ReferralsDatetime from 'components/page-elements/ReferralsDatetime'
    import ReferralsCounterComponent from 'components/page-elements/ReferralsCounterComponent'

    export default {
        components: {
            ReferralsDatetime,
            ReferralsCounterComponent,
        },

        props: {
            referral: { type: Object, required: true },
            showCloseButton: { type: Boolean, default: false },
            showBellIcon: { type: Boolean, default: true },
            totalNumber: { type: Number, required: false, default: null },
            currentIndex: { type: Number, required: false, default: 0 },
        },

        computed: {
            patientName() {
                let patient = this.referral.patient
                return `${patient.firstName} ${patient.lastName}`
            },

            displayAppointmentDateTime() {
                return dayjs(this.referral.appointmentDateTime).format('MMMM DD, HH:mm A')
            },
        },
    }
</script>

<style lang="scss" scoped>
    header {
        text-align: center;

        .notification-icon {
            min-width: 35px;
            z-index: 1;
            position: relative;
            padding-bottom: 30px;
        }

        p {
            font-size: 18px;
            color: #666666;
            word-spacing: 0.01em;
        }
    }

    main {
        .appointment_date {
            display: flex;
            justify-content: center;
        }

        h4 {
            font-family: Poppins;
            font-size: 22px;
            text-align: center;
            margin-bottom: 1rem;
            color: #333333;
            padding-top: 30px;
        }
    }

    footer {
        text-align: center;
    }
    strong {
        color: #333333;
    }
</style>
